import React from 'react'
import Link from 'gatsby-link'
import logo from '../images/logo_color.svg'
import $ from 'jquery'
import { track_click }  from '../components/tracking'


export default class Nav extends React.Component {
  render()
  {
    let Pages = this.props.Pages;
    let location = this.props.location;
    let _pages = []
    for (let ip = 0; ip < Pages.length; ip++) {
      let _page1 = Pages[ip];
      if(_page1.node.context != undefined && _page1.node.context.node != null && _page1.node.context.node.type != "video")
      {
        _pages.push(_page1);
      }
      
    }
    _pages.sort((a,b) => {return a.node.context.node.index - b.node.context.node.index } );

    let _index = 0;
    let indexActual = 0;
    let _base = process.env.PREFIX_PATH;
    
    function get_index_current_path(){
      for (let ip1 = 0; ip1 < _pages.length; ip1++) {
        let _page2 = _pages[ip1];
        if(_base + _page2.node.path + (process.env.NODE_ENV == "development" ? '' : '/') == location){
          return _page2.node.context.node.index - 1;
        }
      }
      return -1;
    }

    var current_index = get_index_current_path();
    var anterior = _pages[ current_index > 0 ? current_index -1 : 0 ].node;
    var siguiente = _pages[ current_index < _pages.length -1 ? current_index + 1 : 0 ].node;
    
    return(
      <div className="nav_internal" style={{  zIndex:'1'}}>
          <a href={ _base + (current_index == 0 ? "/" : anterior.path) }>{current_index == 0 ? "Portada": "Anterior"}</a>
          <a href={ _base + (current_index == (_pages.length -1) ? "/" :siguiente.path ) }>{current_index == (_pages.length-1) ? "Portada": "Siguiente"}</a>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/navInterno.js